import { Box, Text } from '@chakra-ui/react';

interface NavigationTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  isEmployee?: boolean;
  isAdmin?: boolean;
  isManager?: boolean;
}

export function NavigationTabs({
  activeTab,
  onTabChange,
  isEmployee = false,
  isAdmin = false,
  isManager = false,
}: NavigationTabsProps) {
  if (!isAdmin && !isManager) {
    return null;
  }

  const tabs = isAdmin
    ? [
        { id: 'conversations', label: 'Conversations' },
        ...(isEmployee ? [] : [{ id: 'dashboard', label: 'Dashboard' }]),
        { id: 'channels', label: 'Channels' },
      ]
    : [
        { id: 'conversations', label: 'Conversations' },
        { id: 'dashboard', label: 'Dashboard' },
      ];

  return (
    <Box
      width="100%"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      py={0}
      px={2}
      minWidth="200px"
      flexShrink={0}
      flex="1"
      maxWidth="400px"
    >
      <Box
        bg="gray.100"
        borderRadius="full"
        p={1}
        display="flex"
        gap={1}
        boxShadow="sm"
      >
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            as="button"
            px={4}
            py={2}
            position="relative"
            fontWeight="medium"
            color={activeTab === tab.id ? 'gray.900' : 'gray.600'}
            borderRadius="full"
            transition="all 0.2s ease"
            cursor="pointer"
            bg={activeTab === tab.id ? 'white' : 'transparent'}
            boxShadow={activeTab === tab.id ? 'sm' : 'none'}
            border="none"
            outline="none"
            _hover={{
              color: activeTab === tab.id ? 'gray.900' : 'gray.800',
            }}
            _active={{
              transform: 'scale(0.98)',
            }}
            _focus={{
              boxShadow: activeTab === tab.id ? 'sm' : 'outline',
            }}
            onClick={() => onTabChange(tab.id)}
          >
            <Text fontSize="sm">{tab.label}</Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
